/*
 * JDDPRODUCT — global enhancements (~3 KB).
 * Without JS the theme still works: forms post to /cart/add, cart links go to /cart,
 * quantity links hit /cart/change, filters submit normally.
 */
(() => {
  const root = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
  const drawer = () => document.getElementById('CartDrawer');

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-qty-minus], [data-qty-plus]');
    if (!btn) return;
    const input = btn.closest('[data-qty]').querySelector('input');
    const step = Number(input.step) || 1;
    const min = Number(input.min) || 1;
    const max = input.max ? Number(input.max) : Infinity;
    const val = Number(input.value) || min;
    input.value = Math.min(Math.max(btn.hasAttribute('data-qty-plus') ? val + step : val - step, min), max);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- <details> menus: close button, click outside, Esc ---------- */
  document.addEventListener('click', (e) => {
    const closeBtn = e.target.closest('[data-details-close]');
    if (closeBtn) closeBtn.closest('details').open = false;
    document.querySelectorAll('details[data-close-outside][open]').forEach((d) => {
      if (!d.contains(e.target)) d.open = false;
    });
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('details[data-close-outside][open]').forEach((d) => {
      d.open = false;
      d.querySelector('summary')?.focus();
    });
  });

  /* ---------- Cart drawer ---------- */
  const renderDrawer = (html) => {
    const d = drawer();
    if (!d || !html) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.getElementById('CartDrawerInner');
    const current = document.getElementById('CartDrawerInner');
    if (fresh && current) {
      current.replaceWith(fresh);
      document.dispatchEvent(new CustomEvent('jdd:cart-rendered'));
    }
    const count = fresh ? fresh.dataset.cartCount : null;
    if (count !== null) document.querySelectorAll('[data-cart-count]').forEach((el) => {
      if (el.id !== 'CartDrawerInner') el.textContent = Number(count) > 0 ? count : '';
    });
  };

  let engagementRequested = false;
  const loadEngagement = () => {
    if (window.JDDEngagementReady || engagementRequested) return;
    const url = document.body.dataset.engagementUrl;
    if (!url) return;
    engagementRequested = true;
    const script = document.createElement('script');
    script.src = url;
    script.onerror = () => { engagementRequested = false; script.remove(); };
    document.head.appendChild(script);
  };

  const openDrawer = () => {
    const d = drawer();
    if (d?.querySelector('[data-cart-reserved]')) loadEngagement();
    if (d && !d.open) {
      d.showModal();
      document.dispatchEvent(new CustomEvent('jdd:cart-opened'));
    }
  };

  const cartFetch = (url, body) =>
    fetch(url, {
      method: 'POST',
      headers: body instanceof FormData ? { Accept: 'application/json' } : { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body instanceof FormData ? body : JSON.stringify(body),
    }).then((r) => r.json());

  // Add to cart (product forms) → drawer
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('[data-product-form]');
    if (!form || !drawer()) return;
    const submitter = e.submitter;
    if (submitter && submitter.name === 'return_to') return; // direct checkout: let the browser post
    e.preventDefault();
    const btn = form.querySelector('[data-atc]');
    const error = form.querySelector('[data-form-error]');
    const data = new FormData(form);
    data.append('sections', 'cart-drawer');
    data.append('sections_url', location.pathname);
    btn && btn.classList.add('is-loading');
    cartFetch(`${root}cart/add.js`, data)
      .then((res) => {
        if (res.status) {
          if (error) {
            error.textContent = res.description || res.message;
            error.hidden = false;
          }
          return;
        }
        if (error) error.hidden = true;
        renderDrawer(res.sections && res.sections['cart-drawer']);
        openDrawer();
      })
      .catch(() => form.submit())
      .finally(() => btn && btn.classList.remove('is-loading'));
  });

  // Quantity / remove links inside drawer
  document.addEventListener('click', (e) => {
    const link = e.target.closest('#CartDrawer [data-cart-change]');
    if (!link) return;
    e.preventDefault();
    link.closest('.cart-item')?.style.setProperty('opacity', '.5');
    cartFetch(`${root}cart/change.js`, {
      line: Number(link.dataset.cartChange),
      quantity: Number(link.dataset.quantity),
      sections: 'cart-drawer',
      sections_url: location.pathname,
    }).then((res) => renderDrawer(res.sections && res.sections['cart-drawer']));
  });

  // Cart icon opens drawer
  document.addEventListener('click', (e) => {
    const link = e.target.closest('[data-cart-link]');
    if (!link || !drawer()) return;
    e.preventDefault();
    openDrawer();
  });

  // Click on backdrop closes drawer
  document.addEventListener('click', (e) => {
    const d = drawer();
    if (d && e.target === d) d.close();
  });

  /* ---------- Auto-submit (sort / filters) ---------- */
  document.addEventListener('change', (e) => {
    const el = e.target.closest('[data-autosubmit]');
    if (el && el.form) el.form.requestSubmit ? el.form.requestSubmit() : el.form.submit();
  });

  /* ---------- Product recommendations (lazy) ---------- */
  const recos = document.querySelectorAll('[data-recommendations]');
  if (recos.length && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        io.unobserve(entry.target);
        fetch(entry.target.dataset.url)
          .then((r) => r.text())
          .then((html) => {
            const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-recommendations]');
            if (fresh && fresh.innerHTML.trim()) entry.target.innerHTML = fresh.innerHTML;
          });
      });
    }, { rootMargin: '0px 0px 400px 0px' });
    recos.forEach((el) => io.observe(el));
  }

  /* ---------- Sticky header + scroll to top (one passive scroll listener) ---------- */
  const headerInner = document.querySelector('.header-wrapper[data-sticky]');
  const header = headerInner && headerInner.closest('.shopify-section');
  const stickyMode = headerInner ? headerInner.dataset.sticky : 'none';
  const toTop = document.querySelector('[data-to-top]');
  if (header && stickyMode !== 'none') header.classList.add('is-sticky');
  let lastY = window.scrollY;
  let ticking = false;
  const onScroll = () => {
    const y = window.scrollY;
    if (header && stickyMode === 'on-scroll-up') {
      header.classList.toggle('is-hidden', y > lastY && y > header.offsetHeight);
    }
    if (toTop) toTop.classList.toggle('is-visible', y > 400);
    lastY = y;
    ticking = false;
  };
  window.addEventListener('scroll', () => {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(onScroll);
    }
  }, { passive: true });
  toTop?.addEventListener('click', (e) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });

  /* ---------- Offer countdown (real end date from theme settings) ---------- */
  const pad = (n) => String(n).padStart(2, '0');
  let offerTick;
  const updateOffers = () => {
    clearTimeout(offerTick);
    const timers = document.querySelectorAll('[data-offer-end]');
    if (document.hidden || !timers.length) return;
    timers.forEach((el) => {
      const left = Number(el.dataset.offerEnd) - Math.floor(Date.now() / 1000);
      if (left <= 0) return el.remove();
      const clock = el.querySelector('[data-offer-clock]');
      const d = Math.floor(left / 86400);
      if (clock) clock.textContent = `${d ? `${d}d ` : ''}${pad(Math.floor((left % 86400) / 3600))}:${pad(Math.floor((left % 3600) / 60))}:${pad(left % 60)}`;
    });
    if (document.querySelector('[data-offer-end]')) offerTick = setTimeout(updateOffers, 1000);
  };
  updateOffers();
  document.addEventListener('jdd:cart-rendered', updateOffers);
  document.addEventListener('visibilitychange', updateOffers);


  /* ---------- Theme editor ---------- */
  document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('[data-live-counter]')) loadEngagement();
  });
  document.addEventListener('shopify:section:select', (e) => {
    if (e.target.querySelector('#CartDrawer')) openDrawer();
  });
})();
